export function safeStringify(obj) {
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, value) => {
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    });
}
const locks = new Map();
export function acquireLock(key, fn) {
    if (!locks.has(key)) {
        const promise = fn().finally(() => {
            locks.delete(key);
        });
        locks.set(key, promise);
        return promise;
    }
    return locks.get(key);
}
